<script lang="ts">
	import { enhance } from '$app/forms';
	import Image from '$lib/components/Image.svelte';
	import InputControl from '$lib/components/forms/InputControl.svelte';
	import type { SubmitFunction } from '@sveltejs/kit';
	import { getAnalytics, logEvent } from 'firebase/analytics';
	import { draw } from 'svelte/transition';

	let subscribeState: 'idle' | 'loading' | 'success' | Error = 'idle';
	const handleSubscribe: SubmitFunction = async () => {
		logEvent(getAnalytics(), 'generate_lead', {
			content_type: 'email',
			content_id: 'early_access',
			path: window.location.pathname,
		});
		subscribeState = 'loading';
		return async ({ update, result }) => {
			await update();
			subscribeState = 'success';
			switch (result.type) {
				case 'failure':
					console.error(result.data);
					break;
			}
		};
	};
</script>

<p class="text-center text-2xl font-bold">Don't miss new stories and features!</p>
<Image
	class="mx-auto mt-4 rotate-90"
	w="48px"
	alt="arrow pointing down"
	src="arrows/arrow-right-pencil.png" />
<form
	class="join mt-8 flex justify-center"
	action="/subscribe"
	method="POST"
	use:enhance={handleSubscribe}>
	<InputControl>
		<input
			class="join-item h-[3rem] px-6 py-2 text-black"
			name="email"
			type="email"
			required
			on:input={() => (subscribeState = 'idle')}
			placeholder="Enter your email address" />
	</InputControl>
	<button class="btn btn-accent join-item w-32" disabled={subscribeState !== 'idle'}>
		{#if subscribeState === 'idle'}
			Sign up
		{:else if subscribeState === 'loading'}
			<div class="loading loading-spinner h-4 w-4" />
		{:else if subscribeState === 'success'}
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="lucide lucide-check"><path in:draw d="M20 6 9 17l-5-5" /></svg>
		{/if}
	</button>
</form>
